exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".leadsTable-8d911 table>tbody>tr>td{padding:0}.leadsTable-8d911 table>tbody>tr>td a{display:block;color:#000}", ""]);

// Exports
exports.locals = {
	"leadsTable": "leadsTable-8d911"
};